import classNames from 'classnames';
import React, { ComponentProps } from 'react';

import styles from './Loading.module.css';
import Spinner from './Spinner';

export default function Loading({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div className={classNames(styles.Loading, className)} {...props}>
      <Spinner size="80px" />
    </div>
  );
}
